import { createConsts, createActions } from '../../utils/redux';
import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';

const supportedActions = ['HIDE', 'SHOW', 'SET_TIMER', 'STOP_TIMER'];

export const consts = createConsts(
  'communities',
  'joinPopup',
  ...supportedActions,
);
export const actions = createActions(consts);

const initialState = {
  visible: false,
  secondaryContentVisible: false,
  content: '',
  timer: false,
};

export default (
  state = {
    visible: false,
  },
  action,
) => {
  switch (action.type) {
    case consts.SHOW:
      return {
        ...state,
        visible: true,
        content: action.payload.content,
      };
    case consts.HIDE:
      return {
        ...state,
        visible: false,
        content: '',
      };
    case consts.SET_TIMER:
      return {
        ...state,
        timer: true,
      };
    case consts.STOP_TIMER:
      return {
        ...state,
        timer: false,
      };
    case LOCATION_CHANGE:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/communities/joinPopup.js